var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"box"},[_c('lista-list',{ref:"list"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }